import { ChatRepository } from 'application/repositories/ChatRepository';
import {
    AttachmentQuery,
    ChatCountResponse,
    ChatHistoryQuery,
    FileUploadPayload,
    MessageStatusPayload,
    MessageUploadPayload,
} from 'domain/entities/ChatEntity';

export class ChatUseCase implements ChatUseCaseInterface {
    private chatRepo: ChatRepository;

    private websocketConnection = null;

    setWebsocketConnection(websocketConnection: any) {
        this.websocketConnection = websocketConnection;
    }

    constructor(propertyRepo: ChatRepository) {
        this.chatRepo = propertyRepo;
    }

    async getChatRoom(): Promise<any> {
        return await this.chatRepo.getChatRoom();
    }

    async getChatHistory(query: ChatHistoryQuery): Promise<any> {
        return await this.chatRepo.getChatHistory(query);
    }

    async getUnreadMessage(): Promise<ChatCountResponse> {
        return await this.chatRepo.getUnreadMessage();
    }

    async postMessage(payload: MessageUploadPayload): Promise<any> {
        return await this.chatRepo.postMessage(payload);
    }

    async postMessageStatus(payload: MessageStatusPayload): Promise<any> {
        return await this.chatRepo.postMessageStatus(payload);
    }

    async postUploadFile(payload: FileUploadPayload): Promise<any> {
        return await this.chatRepo.postUploadFile(payload);
    }

    async getAttachmentFile(query: AttachmentQuery): Promise<any> {
        return await this.chatRepo.getAttachmentFile(query);
    }

    async updateChatSetting(): Promise<any> {
        return await this.chatRepo.updateChatSetting();
    }
}
export interface ChatUseCaseInterface {
    getChatRoom(): Promise<any>;
    getChatHistory(query: ChatHistoryQuery): Promise<any>;
    getUnreadMessage(): Promise<any>;
    postMessage(payload: MessageUploadPayload): Promise<any>;
    postMessageStatus(payload: MessageStatusPayload): Promise<any>;
    postUploadFile(payload: FileUploadPayload): Promise<any>;
    getAttachmentFile(query: AttachmentQuery): Promise<any>;
    updateChatSetting(): Promise<any>;
}
